import { IYmaps } from './types';
import { insertScriptToLoadYmaps } from './ymaps-loading';

export interface IYmapsApiInterface {
  preloadYmaps(modules: string[]): Promise<IYmaps>;
  loadYmaps(modules: string[]): Promise<IYmaps>;
}

export class YmapsApi implements IYmapsApiInterface {
  private ymapsP: Promise<IYmaps>;

  public preloadYmaps(modules: string[]) {
    return this.loadYmaps(modules);
  }

  public loadYmaps(modules: string[]) {
    if (!this.ymapsP) {
      this.ymapsP = insertScriptToLoadYmaps();
    }

    return this.ymapsP.then(ymaps => ymaps.load(modules));
  }
}
